import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Features from "./components/Features/Features";
import Info from "./components/Info/Info";
import Tips from "./components/Tips/Tips";
import Footer from "./components/Footer/Footer";
import Testimonials from "./components/Testimonials/Testimonials";
import DietPlan from "./components/DietPlan/DietPlan"; // New component
import AboutUs from "./components/AboutUs/AboutUs";
import Terms from "./components/Terms/Terms";
import Disclaimer from "./components/Disclaimer/Disclaimer";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import ContactUs from "./components/ContactUs/ContactUs";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <Features />
            <Info />
            <Testimonials />
            <Tips />
          </>
        } />
        <Route path="/diet-plan" element={<DietPlan />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;